/**
 * Display helpers for the Type 3 escalation sub-flow (Steps 5–9). The file-level
 * stage stays at `escalation` throughout; these steps are tracked under their own
 * stageData keys (see contracts `StageDataBag`).
 */

export const ESCALATION_STEPS = ['step_5', 'step_6', 'step_7', 'step_8', 'step_9'] as const;
export type EscalationStep = (typeof ESCALATION_STEPS)[number];

export function escalationStepLabelKey(step: EscalationStep): string {
  return `gov.escalation.steps.${step}`;
}

/** The statutory hook each escalation step hangs off, surfaced discreetly. */
export const ESCALATION_STEP_REF: Record<EscalationStep, string> = {
  step_5: 'LGA s. 134',
  step_6: 'LGA s. 135',
  step_7: 'LGA s. 137',
  step_8: 'LGA s. 143',
  step_9: 'LGA s. 137 / s. 72',
};

/** The route slug (e.g. `step-5`) used in `/files/:id/escalation/:step`. */
export function escalationStepSlug(step: EscalationStep): string {
  return step.replace('_', '-');
}

export function escalationStepFromSlug(slug: string): EscalationStep | null {
  const step = slug.replace('-', '_') as EscalationStep;
  return ESCALATION_STEPS.includes(step) ? step : null;
}

// Statutory clocks now live in @munifocus/domain-deadlines — the single source
// of truth shared with gov-api's /deadlines endpoint and the reminder
// scheduler. Re-exported here so the escalation step screens keep their import.
export {
  APPEAL_WINDOW_DAYS,
  KINGS_BENCH_WINDOW_DAYS,
  PROCEEDINGS_LIMITATION_MONTHS,
  appealClock,
  clockFromDeadline,
  proceedingsLimitationClock,
  statutoryClock,
  type AppealClock,
  type StatutoryClock,
} from '@munifocus/domain-deadlines';
